import {Component,Inject, Input} from 'ng-metadata/core';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';

import {TimesCitedService} from './timesCited.service';
import {beacon,PrimolyticsService} from "../../analytics/primolytics.service";

@Component({
    selector: 'prm-times-cited',
    templateUrl: 'components/search/timesCited/times-cited.html',
})

export class PrmTimesCited {
    @Input() item: PrimoResponse.IDoc;
    private availabilityLineIcons: Object[];
    constructor(private timesCitedService: TimesCitedService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('availabilityLineIcons') availabilityLineIcons,
                private primolyticsService: PrimolyticsService) {
        this.availabilityLineIcons = availabilityLineIcons;
    }

    get citedData(){
       return this.timesCitedService.citedData;
    }

   public citedLink(item){
        return item['citedLink'];
   }
    public extensionVal(item){
        return item['extensionVal'];
    }
    public recordLink(item){
        return item['recordLink'];
    }
    public vendorLogo(item){
        if (item['citedRedId'].startsWith("scopus")){
            return "img/logo_scopus_s.png";
        }
        else{
            return "img/svg/logo_wos_s.svg";
        }
    }

    public isTimesCitedExists(){
        return this.timesCitedService.citedData != undefined;
    }

    public scopOrWosTrans(item){
        if ( item['citedRedId'].startsWith("scopus")){
            return this.$translate.instant('citationsTab.pc_citation_scopus_label');
        }
        return this.$translate.instant('citationsTab.pc_citation_wos_label');
    }
  //  @beacon({'p':'linksService', 'op': 'TimesCited', 'item':this.item})
    public reportBeacon(){
        this.doBeacon(this.item)
    }
    @beacon({'p':'linksService', 'op': 'TimesCited', 'item':'item'})
    public doBeacon(item){

    }

    private getAraiaLabelForTimeCited(item){
        return this.$translate.instant('citationsTab.viewCitations', {'idx_0' :  this.extensionVal(item)});
    }

    private getTimeCitedType(item) {

        if (item != undefined && item['citedRedId'].startsWith("scopus")){
            return this.$translate.instant('citationsTab.pc_citation_scopus_label');
        }

        else{
            return this.$translate.instant('citationsTab.pc_citation_wos_label');
        }
    }

     get shouldDisplayTimesCited(){
        return this.timesCitedService.shouldDisplayTimesCited;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/timesCited/timesCited.directive.ts